import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables, breakpoints }) => ({
  techListingContainer: {
    padding: `${variables?.spacingG} ${variables?.spacingJ} ${variables?.spacingJ}`,
    fontSize: '16px',
    lineHeight: '1.4',
    [breakpoints.down('xs')]: {
      padding: variables?.spacingE
    },
    // Desktop Table Styles
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      border: `1px solid #333`,
      '& td, th': {
        padding: variables?.spacingB,
        border: `1px solid #333`,
        textAlign: 'left'
      },
      // Mobile Table Styles (Card layout)
      [breakpoints.down('xs')]: {
        border: 'none',
        '& thead': {
          display: 'none' // Hide standard headers on mobile
        },
        '& tbody, & th, & td, & tr': {
          display: 'block',
          width: '100%',
          boxSizing: 'border-box'
        },
        // The "Card" container
        '& tr': {
          marginBottom: '16px',
          borderRadius: '8px',
          border: '1px solid #ccc', // Outer border for the card
          overflow: 'hidden', // Ensures the background colors respect the border radius
        },
        // Odd/Even Zebra Striping for the Cards
        '& tr:nth-of-type(odd)': {
          backgroundColor: '#ffffff', // White for odd rows
        },
        '& tr:nth-of-type(even)': {
          backgroundColor: '#f4f4f4', // Light gray for even rows
        },
        '& td': {
          border: 'none',
          borderBottom: '1px solid #ddd', // Inner border between each item in the card
          padding: '12px',
          position: 'relative',
          color: '#333', // Standard text color
        },
        // Removes the inner border from the very last item so it doesn't double up with the card border
        '& td:last-child': {
          borderBottom: 'none'
        },
        // Bold pseudo-element labels injected into each row
        '& td::before': {
          fontWeight: 'bold',
          color: '#000',
          display: 'inline',
          marginRight: '6px'
        },
        // Assuming your cookie table has 5 columns in this order:
        '& td:nth-of-type(1)::before': {
          content: '"Name of technology:"'
        },
        '& td:nth-of-type(2)::before': {
          content: '"Name of supplier:"'
        },
        '& td:nth-of-type(3)::before': {
          content: '"Purpose of technology:"'
        },
        '& td:nth-of-type(4)::before': {
          content: '"Shared with third parties:"'
        },
        '& td:nth-of-type(5)::before': {
          content: '"Lifetime of technology:"'
        }
      }
    },
    '& a': {
      fontWeight: 'bold',
      textDecoration: 'underline',
      // Ensure links inherit the text color for light backgrounds
      [breakpoints.down('xs')]: {
        color: 'inherit'
      }
    }
  }
}));

export default styles;